export default __webpack_public_path__ + "static/media/Graphik-Bold-Web.114730c4.woff";